import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs);
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './components/header/header.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { DevProdInterceptor } from './interceptor/dev-prod.interceptor';
import { API_BASE_URL, APIClient } from '../../../goldstar-share/src/app/api-data/nswag-models';
import { CustomDialogComponent } from '../../../goldstar-share/src/app/components/shared/custom-dialog/custom-dialog.component';
import { GoldenLayoutComponentService } from '../../../goldstar-share/src/app/services/golden-layout-component.service';
import { ShareModule, httpTranslateLoader } from '../../../goldstar-share/src/app/share.module';
import { ClientHomeLoggedOutComponent } from './components/client-facing/client-home-logged-out/client-home-logged-out.component';
import { ClientHeaderLoggedOutComponent } from './components/client-facing/client-header-logged-out/client-header-logged-out.component';
import { ClientHeaderLogoOnlyComponent } from './components/client-facing/client-header-logo-only/client-header-logo-only.component';
import { DxSelectBoxModule, DxTextAreaModule, DxFormModule, DxNumberBoxModule, DxCheckBoxModule, DxTabPanelModule, DxTemplateModule, DxTabsModule, DxCalendarModule } from 'devextreme-angular';
import { DevExtremeModule } from 'devextreme-angular';
import { StoreModule } from '@ngrx/store';
import { storeReducer } from './store/store.reducer';
import { ApiModule as ApiModuleUpdate } from '../../../goldstar-share/src/app/api-data/ng-openapi-gen-next/api.module';
import { ScreenSizeObserverService } from './services/screen-size-observer.service';
import { SharedComponentModule } from './shared/shared-component.module';
import { SessionService } from './services/session.service';
import { AddressAutocompleteComponent } from '../../../goldstar-share/src/app/components/shared/address-autocomplete/address-autocomplete.component';
import { ApplicationCommonModule } from './modules/application-common/application-common.module';
import { ClientTokenProviderService } from './modules/application-common/services/client-token-provider.service';
import { TranslateInPipeModule } from './pipes/translate-in-pipe';
import config from 'devextreme/core/config';
import { devextremeLicenseKey } from './devextreme-license';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RetryInterceptor } from './interceptor/retry-interceptor';

config({ licenseKey: devextremeLicenseKey });
@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		CustomDialogComponent,
		ClientHomeLoggedOutComponent,
		ClientHeaderLoggedOutComponent,
		ClientHeaderLogoOnlyComponent,
	],
	bootstrap: [AppComponent],
	imports: [
		CommonModule,
		BrowserModule,
		DevExtremeModule,
		DxSelectBoxModule,
		DxTextAreaModule,
		DxFormModule,
		DxNumberBoxModule,
		AppRoutingModule,
		ApplicationCommonModule,
		BrowserAnimationsModule,
		ShareModule,
		StoreModule.forRoot({ store: storeReducer }),
		ApiModuleUpdate.forRoot({ rootUrl: environment.nodeApiRoot }),
		DxTabPanelModule,
		DxCheckBoxModule,
		DxTemplateModule,
		DxTabsModule,
		DxCalendarModule,
		SharedComponentModule,
		AddressAutocompleteComponent,
		TranslateInPipeModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: httpTranslateLoader,
				deps: [HttpClient],
			},
		}),
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: DevProdInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
		GoldenLayoutComponentService,
		{ provide: API_BASE_URL, useValue: environment.apiRoot },
		APIClient,
		{ provide: 'environment', useValue: environment },
		ScreenSizeObserverService,
		{ provide: APP_INITIALIZER, useFactory: onAppInit, deps: [ClientTokenProviderService, SessionService], multi: true },
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AppModule {}

export function onAppInit(tokenService: ClientTokenProviderService, sessionService: SessionService) {
	return () => tokenService.fetchAllowedRoutes().then(() => sessionService.generateSession());
}
